'use strict';

export default ($filter) => {
  'ngInject';

  const toDateFilter = $filter('toDate');
  const dateFilter = $filter('date');

  return (date, shouldShowFullMonthName) => {
    let result = '';
    const monthFormat = (shouldShowFullMonthName ? 'MMMM' : 'MMM');

    if (angular.isString(date) || angular.isNumber(date)) {
      result =  dateFilter(toDateFilter(date), 'd ' + monthFormat + ' yyyy');
    }

    return result;
  };
};



// WEBPACK FOOTER //
// ./app/src/filters/booking_date.js